import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Config Metadata',
  attributeName: 'configName',
  isExpand: false,
  default: {
    minBuildNumber: 1
  },
  fields: [
    {
      attributeName: 'configName',
      helpText: 'Comment to identify this group od config data',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      disabled: true
    },
  ],
};
